var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"main"},[_c('post')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }